var _circle, _circle2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwoPeople(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 6,
    r: 3,
    stroke: "#14142B",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 8.5,
    r: 2.5,
    stroke: "#14142B",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 18C1 14.6863 3.68629 12 7 12C10.3137 12 13 14.6863 13 18V20H1V18Z",
    stroke: "#14142B",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 14V13V14ZM12.5381 15.6875L11.6155 16.0732L11.3621 15.4672L11.8176 14.994L12.5381 15.6875ZM13 18H14H13ZM13 20V21H12V20H13ZM22 20H23V21H22V20ZM22 19.5H23H22ZM16.5 14V15C15.2268 15 14.079 15.5286 13.2586 16.381L12.5381 15.6875L11.8176 14.994C12.9984 13.7673 14.6596 13 16.5 13V14ZM12.5381 15.6875L13.4607 15.3018C13.8084 16.1334 14 17.0456 14 18H13H12C12 17.3152 11.8628 16.6649 11.6155 16.0732L12.5381 15.6875ZM13 18H14V20H13H12V18H13ZM13 20V19H22V20V21H13V20ZM22 20H21V19.5H22H23V20H22ZM22 19.5H21C21 17.0147 18.9853 15 16.5 15V14V13C20.0899 13 23 15.9101 23 19.5H22Z",
    fill: "#14142B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoPeople);
export default __webpack_public_path__ + "static/media/Two People.a4374948c80bba0cb059fbbc739d21a5.svg";
export { ForwardRef as ReactComponent };